import { connect } from 'react-redux';
import GuidesConfig from './guides_config';
import { closePanel } from '../../actions/panel';
import {
  showRuler, hideRuler,
  showGuides, hideGuides,
  showWidth, hideWidth, setWidth,
  showHeight, hideHeight, setHeight
} from '../../actions/canvas';

const mapStateToProps = ({ canvas }) => canvas;

export default connect(mapStateToProps, {
  closePanel,
  showRuler,
  hideRuler,
  showGuides,
  hideGuides,
  showWidth,
  hideWidth,
  setWidth,
  showHeight,
  hideHeight,
  setHeight
})(GuidesConfig);
